import React from 'react'

import {
  TableContainerStyled,
  TableStyled,
  TableFooter,
  TableCellStyled,
  TableRowStyled,
  TableBodyStyled,
  TableHeadStyled,
  CheckBox,
  Row
} from 'components'
import { ViewFileIcon } from 'components/Icons'
import { IDocsItems } from 'services/NGT/DjurServices'
import { useFile } from 'hooks'
import { FORMAT } from 'utils'

interface ITableDocuments {
  tableData: IDocsItems[]
  paginationControl: [number, React.Dispatch<React.SetStateAction<number>>]
  rowsPerPageControl: [number, React.Dispatch<React.SetStateAction<number>>]
  pageCount: number
  isConsult?: boolean
  handleSelectItem: (_row: IDocsItems) => void
  handleToWaive: (_row: IDocsItems) => void
  handleCheckAll: () => void
  isAllChecked: boolean
}

const TableDocuments: React.FC<ITableDocuments> = ({
  tableData,
  paginationControl,
  rowsPerPageControl,
  pageCount,
  isConsult,
  handleSelectItem,
  handleToWaive,
  handleCheckAll,
  isAllChecked
}) => {
  const { viewFile } = useFile()

  const [page, setPage] = paginationControl
  const [rowsPerPage, setRowsPerPage] = rowsPerPageControl

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(1)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="center" padding="checkbox">
                {!isConsult && (
                  <CheckBox checked={isAllChecked} onChange={handleCheckAll} />
                )}
              </TableCellStyled>
              <TableCellStyled>Contrato</TableCellStyled>
              <TableCellStyled>Tipo Documento</TableCellStyled>
              <TableCellStyled>Competência</TableCellStyled>
              <TableCellStyled align="center">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData.length > 0 &&
              tableData.map((row: IDocsItems, index) => (
                <TableRowStyled key={index + row.contrato}>
                  <TableCellStyled align="center">
                    {!isConsult && (
                      <CheckBox
                        checked={row.checked}
                        onChange={() => {
                          if (row.checked) {
                            handleToWaive(row)
                            return
                          }
                          handleSelectItem(row)
                        }}
                      />
                    )}
                  </TableCellStyled>
                  <TableCellStyled>{row.contrato}</TableCellStyled>
                  <TableCellStyled>{row.txDescricaoPendencia}</TableCellStyled>
                  <TableCellStyled align="center">
                    {FORMAT.competencia(row.competencia)}
                  </TableCellStyled>
                  <TableCellStyled minwidth="90px" align="center">
                    <Row justifyContent="center" alignItems="center">
                      <ViewFileIcon
                        onClick={() =>
                          viewFile({ gedExternalID: row.idDocumentoGed })
                        }
                        cursor="pointer"
                      />
                    </Row>
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        totalItems={pageCount}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="online"
      />
    </>
  )
}

export default TableDocuments
